import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { useState } from 'react';
import {message} from 'antd';
import { BASE_URL, DateFormat, DateTimeFormat,TIMEZONE_MAP } from '../Components/Constant';
import ApiService from '../Components/apiService'; // Import ApiService class
import Cookies from 'js-cookie';
dayjs.extend(utc);
dayjs.extend(timezone);



// Function to handle Insert operation
export const generateBody = (fieldsDataDrawer, values, isCreate) => {
  const updatedValues = {};
  let error='';
  fieldsDataDrawer.forEach((field) => {
    const fieldName = field.name;
    if (field.Name === 'CreatedBy' || field.Name === 'LastModifiedBy') {
      return;
    }
    if (field.type === 'lookup') {
      if (field.name === 'CreatedBy' || field.name === 'LastModifiedBy') {
        return;
      }
      if (!(fieldName in values)) return;

      if (!values[fieldName]?._id && !isCreate) {
        updatedValues[`${fieldName}`] = values[fieldName] ?? null;
      }
      else if (isCreate) {
        updatedValues[`${fieldName}`] = values[fieldName]?._id || values[fieldName];
      }

    }
    else if (field.type === 'address') {
      updatedValues[fieldName] = {
        street: values[`${field.name}_street`],
        city: values[`${field.name}_city`],
        state: values[`${field.name}_state`],
        country: values[`${field.name}_country`],
        postal_code: values[`${field.name}_postalcode`]
      };
    }

    else if (
      (field.type === 'richtext' || field.type === 'textarea') &&
      field.required &&
      values[field.name] !== null &&
      values[field.name] !== undefined &&
      values[field.name] !== '' &&
      values[field.name].replace(/<[^>]*>/g, '').trim() === ''
    ) {
      message.error(`${field.label} is required`);
      error = "error";
    }
    
    else if (field.type === 'percentage') {
      updatedValues[fieldName] = values[fieldName] / 100;
    }
    else if (field.type === 'date') {
      const utcDate = generateUTCMidnightDate(values[fieldName]);
      updatedValues[fieldName] = utcDate;
    }
    else if (field.type === 'datetime') {
      const utcDate = generateUTCDate(values[fieldName]);
      updatedValues[fieldName] = utcDate;
    }
    else {
      updatedValues[fieldName] = values[fieldName];
    }
  });

  return error==='error' ? 'error' :updatedValues;
};

export const fetchCurrency = async () => {
  try {
  
      const apiService = new ApiService(`${BASE_URL}/mt_currencies`, {
          'Content-Type': 'application/json',
      }, 'GET');
      const response = await apiService.makeCall();
      return response;
  } catch (err) {
      console.error("Error fetching metadata:", err);
  }
}

export const generateUTCDate = (date) => {
  if (dayjs.isDayjs(date)) {
    return undefined;
  }

  try {
    const formatPattern = date.includes(':') ? DateTimeFormat : DateFormat;

    const timezoneFromCookie = Cookies.get('timezone') || 'UTC';
    // Parse in the user's timezone first, then convert to UTC
    const utcDate = dayjs.tz(date, formatPattern, timezoneFromCookie).utc().format('YYYY-MM-DDTHH:mm:ss[Z]');
    return utcDate;
  } catch (error) {
    console.error("Error converting date to UTC:", error);
    return null;
  }
};

export const generateUTCMidnightDate = (dateStr) => {
  if (!dateStr) return null;

  try {
    // Step 1: Parse the date using your provided DateFormat (e.g., 'DD/MM/YYYY')
    const parsedDate = dayjs(dateStr, DateFormat, true); // true = strict parsing

    if (!parsedDate.isValid()) {
      throw new Error(`Invalid date for format ${DateFormat}: ${dateStr}`);
    }

    // Step 2: Convert to UTC midnight (00:00:00.000Z)
    const utcMidnight = dayjs.utc(parsedDate.format('YYYY-MM-DD')).startOf('day');

    // Step 3: Return as ISO string
    return utcMidnight.format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
  } catch (error) {
    console.error("Error in generateUTCMidnightDate:", error);
    return null;
  }
};




export const convertDateToUserTimezone = (date, dateFormat) => {
  const rawTimezone = Cookies.get('timezone')?.trim() ? Cookies.get('timezone') : 'UTC';
  // const rawTimezone = Cookies.get('timezone') || 'UTC';

  const mappedTimezone = TIMEZONE_MAP[rawTimezone] || 'UTC';

  const newdate = dayjs.utc(date).tz(mappedTimezone).format(dateFormat);


  return newdate || '';
};


export const convertToDateJSON = (date, DateFormat) => {
  const newdate = dayjs(date, DateFormat);
  return newdate || '';
};





export const colors = ['blue', 'green', 'red', 'purple', 'orange', 'volcano', 'gold', 'cyan', 'lime', 'pink'];

export const getUniqueColor = (index) => {
  // Assign a color based on the index, wrapping around if there are more values than colors
  return colors[index % colors.length];
};

export const formatRecordData = async (record, fieldsResponse, BASE_URL) => {
  const formattedRecord = { ...record };
  // Format address and date fields
  fieldsResponse.forEach(field => {
    if (field.type === 'address' && formattedRecord[field.name]) {
      formattedRecord[`${field.name}_street`] = record[field.name].street || '';
      formattedRecord[`${field.name}_city`] = record[field.name].city || '';
      formattedRecord[`${field.name}_state`] = record[field.name].state || '';
      formattedRecord[`${field.name}_country`] = record[field.name].country || '';
      formattedRecord[`${field.name}_postalcode`] = record[field.name].postal_code || '';
    }

    if (field.type === 'date' && record[field.name]) {
      const converteddate = convertDateToUserTimezone(record[field.name], DateFormat);
      formattedRecord[field.name] = converteddate;
    }
    if (field.type === 'datetime' && record[field.name]) {
      const converteddate = convertDateToUserTimezone(record[field.name], DateTimeFormat);
      formattedRecord[field.name] = converteddate;
    }
    if (field.type === 'percentage' && record[field.name]) {
      formattedRecord[field.name] = record[field.name] * 100;
    }
  });

  return formattedRecord;
};

export const fetchLookupData = (record, fieldsResponse, BASE_URL, setLookupName, form) => {
  const lookupFields = fieldsResponse.filter(field => field.type === 'lookup');

  for (const lookupField of lookupFields) {
    form.setFieldsValue({
      [lookupField.name]: record[lookupField.name]?.Name
    });
  }
};

export const useHoverVisibility = () => {
  const [isHovered, setIsHovered] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [hoverTimeout, setHoverTimeout] = useState(null);

  // Handle mouse enter on the element that triggers the card
  const handleMouseEnter = () => {
    if (hoverTimeout) {
      clearTimeout(hoverTimeout); // Clear the timeout when the mouse enters
    }
    setIsHovered(true); // Keep the component visible when hovering over it
    setIsVisible(true); // Make the content visible immediately
  };

  // Handle mouse leave from the element that triggers the card
  const handleMouseLeave = () => {
    const timeout = setTimeout(() => {
      setIsVisible(false); // Close the component after a delay
    }, 400);
    setHoverTimeout(timeout); // Store the timeout to clear it when hovering over content
  };

  // Handle mouse enter on the content (to prevent closing when hovering over content)
  const handleContentMouseEnter = () => {
    setIsHovered(true); // Keep the component visible when hovering over the content
  };

  // Handle mouse leave from the content (to check for closing)
  const handleContentMouseLeave = () => {
    setIsHovered(false); // Allow the timeout to close the component
  };

  return {
    isHovered,
    isVisible,
    handleMouseEnter,
    handleMouseLeave,
    handleContentMouseEnter,
    handleContentMouseLeave,
  };
};
